import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Flag } from '@packages/shared/src/ui/Flag/Flag';

const messages = defineMessages({
  Co2CompensationFlagStandard: {
    id: 'Co2CompensationFlag.standard',
    defaultMessage: '{flag} durch Kompensation',
  },
  Co2CompensationFlagHint: {
    id: 'Co2CompensationFlag.hint',
    defaultMessage: 'Co2-neutral',
  },
});

export const Co2CompensationFlag = () => {
  const { formatMessage } = useIntl();

  return (
    <FormattedMessage
      {...messages.Co2CompensationFlagStandard}
      values={{
        flag: (
          <Flag variant="sustainability" text={formatMessage(messages.Co2CompensationFlagHint)} />
        ),
      }}
    />
  );
};
